import {Color} from '@benchling/nucleus-ui';
import {Badge} from '@mantine/core';
import React from 'react';

export interface FormatSchemaCountBadgeProps {
  count: number;
}

const BADGE_SIZE = '15px';

export default function FormatSchemaCountBadge({count}: FormatSchemaCountBadgeProps): JSX.Element {
  return (
    <Badge
      size="xs"
      variant="filled"
      radius="xl"
      sx={{
        width: BADGE_SIZE,
        height: BADGE_SIZE,
        minWidth: BADGE_SIZE,
        padding: 0,
        fontSize: '11px',
        fontWeight: 700,
        backgroundColor: Color.GRAY_200,
        color: Color.GRAY_800,
        border: 'none',
      }}
    >
      <span style={{fontWeight: 700}}>{count > 9 ? '+' : count}</span>
    </Badge>
  );
}
